module.exports = __webpack_public_path__ + "img/盖章@3x.6d5cc033.png";